import React, { useState, useRef, useEffect } from 'react';
import { ReactComponent as MuteSVG } from '../../Images/buttons/muteButton.svg';
import { ReactComponent as MuteOFFSVG } from '../../Images/buttons/muteButtonOff.svg';
import { ReactComponent as CameraOFFSVG } from '../../Images/buttons/selectModeFaceWhite.svg';
import { ReactComponent as CameraONSVG } from '../../Images/buttons/selectModeAIWhite.svg';
import { ReactComponent as NFTSVG } from '../../Images/buttons/nftButton.svg';
import { ReactComponent as ScreenShareON } from '../../Images/buttons/screenShareButton.svg';
import { ReactComponent as ScreenShareOFF } from '../../Images/buttons/screenShareOnButton.svg';
import { ReactComponent as TakePicSVG } from '../../Images/buttons/screenShotButton.svg';
import { ReactComponent as RecordStartSVG } from '../../Images/buttons/recordStartButton.svg';
import { ReactComponent as RecordStopSVG } from '../../Images/buttons/recordStopButton.svg';
import { ReactComponent as ChatSVG } from '../../Images/buttons/chatButton.svg';
import { ReactComponent as HangOutSVG } from '../../Images/buttons/hangoutButton.svg';
import { ReactComponent as ArrowSVG } from '../../Images/buttons/smallArrow.svg';
import { ReactComponent as ReactionSVG } from '../../Images/buttons/reactionButton.svg';
import { ReactComponent as HeartSVG } from '../../Images/buttons/heartReaction.svg';
import { ReactComponent as HahaSVG } from '../../Images/buttons/hahaReaction.svg';
import { ReactComponent as CrackerSVG } from '../../Images/buttons/reactionLike.svg';
import { ReactComponent as HandSVG } from '../../Images/buttons/handReaction.svg';
import { ReactComponent as EditNameSVG } from '../../Images/buttons/editNameButton.svg';
import { ReactComponent as ViewCountOFFSVG } from '../../Images/buttons/viewCountIcon.svg';
import { ReactComponent as SpeakerSVG } from '../../Images/buttons/speaker.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as ExitSVG } from '../../Images/buttons/exitButton.svg';
import { ReactComponent as LogoSVG } from '../../Images/buttons/logoButton.svg';
import { ReactComponent as AISVG } from '../../Images/buttons/aimodeWhite.svg';
import { ReactComponent as FacialSVG } from '../../Images/buttons/facialmodeWhite.svg';
import { ReactComponent as TextToSVG } from '../../Images/buttons/texttospeechwhite.svg';
import { ReactComponent as BackgroundSVG } from '../../Images/buttons/backgroundButton.svg';
import { ReactComponent as SettingSVG } from '../../Images/buttons/settingBottomButton.svg';
import { MuteButton } from './MuteButton';
import '../Tray.css';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useDevices } from '@daily-co/daily-react';
import {
  reactionAtom,
  cameraInputAtom,
  micInputAtom,
  tapCameraAtom,
  isTextToSpeechAtom,
} from '../../../State';
import { isMobile } from 'react-device-detect';
import { ViewerCount } from './ViwerCount';
import AddAccess from '../../Util/AddAccess';
import { useTranslation } from 'react-i18next';

//デバイスの一覧を取得
const getDeviceList = async (type) => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    if (type == 'camera') {
      const videoDevices = devices.filter((device) => device.kind === 'videoinput');
      if (videoDevices.length < 1) {
        return null;
      } else {
        return videoDevices;
      }
    }

    if (type == 'audio') {
      const micDevices = devices.filter((device) => device.kind === 'audioinput');
      if (micDevices.length < 1) {
        return null;
      } else {
        return micDevices;
      }
    }

    if (type == 'speaker') {
      const speakerDevices = devices.filter((device) => device.kind === 'audiooutput');
      if (speakerDevices.length < 1) {
        return null;
      } else {
        return speakerDevices;
      }
    }
  } catch (error) {
    return null;
  }
};

/*++++++++++++ マイク開始 ++++++++++++*/

//マイクミュートボタン
export const MicrophoneOn = ({ isOn, toggleAudio, isHairCheck }) => {
  //Recoil系
  // const [cameraInputState, setCameraInputState] = useRecoilState(cameraInputAtom);
  const [micInputState, setMicInputState] = useRecoilState(micInputAtom);

  const { setMicrophone, setSpeaker } = useDevices();
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [audioListState, setAudioListState] = useState(null);
  const [speakerListState, setSpeakerListState] = useState(null);
  const selectedDeviceID = useRef('default');
  const selectedSpeakerDeviceID = useRef('default');
  const { t } = useTranslation();

  async function showList() {
    //マイクデバイス一番を取得
    const audioDevices = await getDeviceList('audio');

    if (audioDevices != null) {
      if (micInputState != '') {
        audioDevices.forEach((device) => {
          if (device.deviceId == micInputState) {
            selectedDeviceID.current = micInputState;
          }
        });
      } else if (
        localStorage.getItem('micInput') != null &&
        localStorage.getItem('micInput') != ''
      ) {
        audioDevices.forEach((device) => {
          if (device.deviceId == localStorage.getItem('micInput')) {
            selectedDeviceID.current = localStorage.getItem('micInput');
          }
        });
      } else {
        selectedDeviceID.current = 'default';
      }

      setAudioListState(audioDevices);
    }

    //スピーカーの一覧
    const speakerDevices = await getDeviceList('speaker');

    if (speakerDevices != null) {
      // if (micInputState != '') {
      //   speakerDevices.forEach((device) => {
      //     if (device.deviceId == micInputState) {
      //       selectedDeviceID.current = micInputState;
      //     }
      //   });
      // } else

      if (
        localStorage.getItem('speakerOutput') != null &&
        localStorage.getItem('speakerOutput') != ''
      ) {
        speakerDevices.forEach((device) => {
          if (device.deviceId == localStorage.getItem('speakerOutput')) {
            selectedSpeakerDeviceID.current = localStorage.getItem('speakerOutput');
          }
        });
      } else {
        selectedSpeakerDeviceID.current = 'default';
      }

      setSpeakerListState(speakerDevices);
    }
  }

  //マイクアロータップ
  const micArrow = async (e) => {
    e.stopPropagation();
    showList();
  };

  //マイクのリストタップ時
  const selectAudio = async (deviceID) => {
    setMicrophone(deviceID);
    setMicInputState(deviceID);
    localStorage.setItem('micInput', deviceID);
    setAudioListState(null);
  };

  //スピーカーのリストタップ時
  const selectSpeaker = async (deviceID) => {
    setSpeaker(deviceID);
    localStorage.setItem('speakerOutput', deviceID);
    setSpeakerListState(null);
  };

  const tapBack = async () => {
    setAudioListState(null);
  };

  //マイクリスト
  function ListItem({ mic }) {
    // --> displays the data / is reusable
    return (
      <li
        onClick={(e) => {
          e.stopPropagation();
          selectAudio(mic.deviceId);
        }}
        className={mic.deviceId == selectedDeviceID.current ? 'audioSelected' : ''}>
        {mic.label}
      </li>
    );
  }

  //スピーカーリスト
  function ListItemSpeaker({ speaker }) {
    return (
      <li
        onClick={(e) => {
          e.stopPropagation();
          selectSpeaker(speaker.deviceId);
        }}
        className={speaker.deviceId == selectedSpeakerDeviceID.current ? 'audioSelected' : ''}>
        {speaker.label}
      </li>
    );
  }

  //レンダー処理
  return (
    <div className="trayButtonWrap">
      {audioListState != null && (
        <>
          <div id="wrapBack" onClick={tapBack}></div>
          <div id="audioList" className="audioListHairCheck">
            <div id="audioListTitle">
              <>{t('bottom.Microphone')}</>
            </div>
            <ul>
              {/* <li className="audioSelected">マイク1</li> */}
              {audioListState?.map((mic) => (
                <ListItem key={mic.deviceId} mic={mic} />
              ))}
            </ul>

            <div id="audioListTitle2">
              <>{t('bottom.Speaker')}</>
            </div>
            <ul>
              {speakerListState?.map((speaker) => (
                <ListItemSpeaker key={speaker.deviceId} speaker={speaker} />
              ))}
            </ul>
          </div>
        </>
      )}
      <button
        onClick={toggleAudio}
        onMouseOver={() => setIsMouseOver(true)}
        onMouseOut={() => setIsMouseOver(false)}>
        {!isOn ? <MuteButton isMouseOver={isMouseOver} /> : <MuteOFFSVG />}

        {!isMobile && (
          <div className="arrowButton" onClick={micArrow}>
            <ArrowSVG />
          </div>
        )}
        <div className="iconName">
          {!isOn ? <>{t('bottom.Mute')}</> : <>{t('bottom.UnMute')}</>}
        </div>
      </button>
    </div>
  );
};

/*++++++++++++ カメラ開始 ++++++++++++*/

export const FaceTrackingButton = ({ isOn, toggleFaceTrack, isHairCheck }) => {
  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得
  let showThisNFT = roomID == 'makopt' || roomID == '144987874' ? true : false;

  //Recoil系
  const [cameraInputState, setCameraInputState] = useRecoilState(cameraInputAtom);
  const [tapCameraState, setTapCameraState] = useRecoilState(tapCameraAtom);
  const [isTextToSpeechState, setIsTextToSpeechState] = useRecoilState(isTextToSpeechAtom);
  const [audioListState, setAudioListState] = useState(null);
  const [modeSelectState, setModeSelectState] = useState(false);
  const selectedDeviceID = useRef('default');
  const initialSkipRef = useRef(true);
  const { t } = useTranslation();

  useEffect(() => {
    //初回ロードスキップ用
    if (initialSkipRef.current) {
      initialSkipRef.current = false;
      return;
    }

    showList();
  }, [tapCameraState]);

  async function showList() {
    //マイクデバイス一番を取得
    const audioDevices = await getDeviceList('camera');

    if (audioDevices != null) {
      if (cameraInputState != '') {
        audioDevices.forEach((device) => {
          if (device.deviceId == cameraInputState) {
            selectedDeviceID.current = cameraInputState;
          }
        });
      } else if (
        localStorage.getItem('cameraInput') != null &&
        localStorage.getItem('cameraInput') != ''
      ) {
        audioDevices.forEach((device) => {
          if (device.deviceId == localStorage.getItem('cameraInput')) {
            selectedDeviceID.current = localStorage.getItem('cameraInput');
          }
        });
      } else {
        selectedDeviceID.current = 'default';
      }

      setAudioListState(audioDevices);
    }
  }

  //マイクアロータップ
  const micArrow = async (e) => {
    e.stopPropagation();
    showList();

    //アクセス
    AddAccess('click', 'micArrow');
  };

  //リストタップ時
  const selectAudio = async (deviceID) => {
    setCameraInputState(deviceID);
    localStorage.setItem('cameraInput', deviceID);
    setAudioListState(null);
  };

  //モード変更ボタン
  const selectModeButton = async () => {
    setModeSelectState(true);
  };

  //モード変更ボタン
  const selectMode = async (mode) => {
    if (!isOn && mode == 'AI') {
      localStorage.setItem('mode', 'ai');
      toggleFaceTrack();
      setIsTextToSpeechState(false);
    }

    if (isOn && mode == 'Facial') {
      localStorage.setItem('mode', 'facial');
      toggleFaceTrack();
      setIsTextToSpeechState(false);
    }

    if (mode == 'TextToSpeech') {
      setIsTextToSpeechState(true);
      //localStorage.setItem('mode', 'ficial');
      //toggleFaceTrack();
    }

    setModeSelectState(false);
  };

  //背景タップ
  const tapBack = async () => {
    setAudioListState(null);
    setModeSelectState(false);
  };

  //リスト
  function ListItem({ mic }) {
    return (
      <li
        onClick={(e) => {
          e.stopPropagation();
          selectAudio(mic.deviceId);
        }}
        className={mic.deviceId == selectedDeviceID.current ? 'audioSelected' : ''}>
        {mic.label}
      </li>
    );
  }

  //レンダー処理
  return (
    <div className="trayButtonWrap">
      {audioListState != null && (
        <>
          <div id="wrapBack" onClick={tapBack}></div>
          <div id="audioList" className="audioListHairCheck">
            <div id="audioListTitle">{t('bottom.Camera')}</div>
            <ul>
              {/* <li className="audioSelected">マイク1</li> */}
              {audioListState?.map((mic) => (
                <ListItem key={mic.deviceId} mic={mic} />
              ))}
            </ul>
          </div>
        </>
      )}
      {modeSelectState && (
        <>
          <div id="wrapBack" onClick={tapBack}></div>
          <div className="extendList">
            <div className="extendMainTitle">{t('bottom.Select Mode')}</div>
            <ul className="listExtend">
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  selectMode('AI');
                }}
                className={isOn && isTextToSpeechState == false ? 'selected' : ''}>
                <div className="extendImage">
                  <AISVG />
                </div>
                <div className="extendText">
                  <div className="extendTitle">{t('bottom.AI Mode')}</div>
                  <div className="extendBody">{t('mypage.Your voice controls the avatar.')}</div>
                </div>
              </li>

              <li
                onClick={(e) => {
                  e.stopPropagation();
                  selectMode('Facial');
                }}
                className={!isOn && isTextToSpeechState == false ? 'selected' : ''}>
                <div className="extendImage">
                  <FacialSVG />
                </div>
                <div className="extendText">
                  <div className="extendTitle"> {t('bottom.Facial Mode')}</div>
                  <div className="extendBody">{t('mypage.Facial info moves avatar.')}</div>
                </div>
              </li>

              {showThisNFT && (
                <li
                  onClick={(e) => {
                    e.stopPropagation();
                    selectMode('TextToSpeech');
                  }}
                  className={isTextToSpeechState ? 'selected' : ''}>
                  <div className="extendImage">
                    <TextToSVG />
                  </div>
                  <div className="extendText">
                    <div className="extendTitle"> {t('mypage.Text to Speech Mode')}</div>
                    <div className="extendBody">{t('mypage.Typed text will be spoken')}</div>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </>
      )}
      <button onClick={selectModeButton}>
        {isOn && isTextToSpeechState == false && (
          <>
            <CameraONSVG />
            <div className="iconName">{t('bottom.AI Mode')}</div>
          </>
        )}

        {!isOn && isTextToSpeechState == false && (
          <>
            <FacialSVG />
            <div className="arrowButton" onClick={micArrow}>
              <ArrowSVG />
            </div>
            <div className="iconName">{t('bottom.Facial Mode')}</div>
          </>
        )}

        {isTextToSpeechState && (
          <>
            <TextToSVG />
            <div className="iconName">{t('bottom.Text Mode')}</div>
          </>
        )}

        {/* {!isOn ? <CameraOFFSVG /> : }

        {!isMobile && !isOn && (
          
        )} */}
        {/* <div className="iconName">
          {!isOn ? <> {t('bottom.Facial Mode')}</> : <> {t('bottom.AI Mode')}</>}
        </div> */}
      </button>
    </div>
  );
};

/*++++++++++++ スピーカー開始 ++++++++++++*/

export const SpeakerButton = ({ isOn, toggleFaceTrack, isHairCheck }) => {
  //Recoil系
  const { setSpeaker } = useDevices();
  const [audioListState, setAudioListState] = useState(null);
  const selectedDeviceID = useRef('default');
  const initialSkipRef = useRef(true);
  const [speakerListState, setSpeakerListState] = useState(null);

  const selectedSpeakerDeviceID = useRef('default');
  const { t } = useTranslation();

  // useEffect(() => {
  //   //初回ロードスキップ用
  //   if (initialSkipRef.current) {
  //     initialSkipRef.current = false;
  //     return;
  //   }

  //   showList();
  // }, [tapCameraState]);

  async function showList() {
    //スピーカーの一覧
    const speakerDevices = await getDeviceList('speaker');

    if (speakerDevices != null) {
      if (
        localStorage.getItem('speakerOutput') != null &&
        localStorage.getItem('speakerOutput') != ''
      ) {
        speakerDevices.forEach((device) => {
          if (device.deviceId == localStorage.getItem('speakerOutput')) {
            selectedSpeakerDeviceID.current = localStorage.getItem('speakerOutput');
          }
        });
      } else {
        selectedSpeakerDeviceID.current = 'default';
      }

      setSpeakerListState(speakerDevices);
    }
  }

  //マイクアロータップ
  const micArrow = async (e) => {
    e.stopPropagation();
    showList();

    //アクセス
    AddAccess('click', 'micArrow');
  };

  //スピーカーのリストタップ時
  const selectSpeaker = async (deviceID) => {
    setSpeaker(deviceID);
    localStorage.setItem('speakerOutput', deviceID);
    selectedSpeakerDeviceID.current = deviceID;

    console.log(deviceID);
    setSpeakerListState(null);
  };

  const tapBack = async () => {
    setSpeakerListState(null);
  };

  //リスト
  function ListItem({ mic }) {
    return (
      <li
        onClick={(e) => {
          e.stopPropagation();
          selectSpeaker(mic.deviceId);
        }}
        className={mic.deviceId == selectedSpeakerDeviceID.current ? 'audioSelected' : ''}>
        {mic.label}
      </li>
    );
  }

  //レンダー処理
  return (
    <div className="trayButtonWrap">
      {speakerListState != null && (
        <>
          <div id="wrapBack" onClick={tapBack}></div>
          <div id="audioList" className="audioListHairCheck">
            <div id="audioListTitle"> {t('bottom.Speaker')}</div>
            <ul>
              {/* <li className="audioSelected">マイク1</li> */}
              {speakerListState?.map((mic) => (
                <ListItem key={mic.deviceId} mic={mic} />
              ))}
            </ul>
          </div>
        </>
      )}
      <button onClick={micArrow}>
        {!isOn ? <SpeakerSVG /> : <SpeakerSVG />}
        <div className="iconName">{t('bottom.Speaker')}</div>
      </button>
    </div>
  );
};

/*++++++++++++ スピーカー終了 ++++++++++++*/

export const Speaker = () => {
  const { t } = useTranslation();
  return (
    <>
      <SpeakerSVG />
      <div className="iconName">{t('bottom.Speaker')}</div>
    </>
  );
};

export const ReactionButton = () => {
  const [isSelected, setIsSelected] = useState(false);
  const setReactionState = useSetRecoilState(reactionAtom);
  const { t } = useTranslation();
  const tapReaction = async () => {
    if (isSelected) {
      setIsSelected(false);
    } else {
      setIsSelected(true);
    }

    //アクセス
    AddAccess('click', 'reaction');
  };

  const tapHeart = async () => {
    setIsSelected(false);
    setReactionState({
      reactionName: 'heart',
      time: new Date(),
    });

    //アクセス
    AddAccess('click', 'reactionButton', 'heart');
  };

  const tapBye = async () => {
    setIsSelected(false);
    setReactionState({
      reactionName: 'bye',
      time: new Date(),
    });

    //アクセス
    AddAccess('click', 'reactionButton', 'bye');
  };

  const tapSmile = async () => {
    setIsSelected(false);
    setReactionState({
      reactionName: 'smile',
      time: new Date(),
    });

    //アクセス
    AddAccess('click', 'reactionButton', 'smile');
  };

  const tapLike = async () => {
    setIsSelected(false);
    setReactionState({
      reactionName: 'like',
      time: new Date(),
    });

    //アクセス
    AddAccess('click', 'reactionButton', 'like');
  };
  return (
    <>
      <div id="reactionButtonWrap">
        {isSelected && (
          <>
            <div id="transparentBox" onClick={tapReaction}></div>
            <div id="reactionButtons">
              <div className="reactionItem" onClick={tapHeart}>
                <HeartSVG />
              </div>
              <div className="reactionItem" onClick={tapSmile}>
                <HahaSVG />
              </div>
              <div className="reactionItem" onClick={tapBye}>
                <HandSVG />
              </div>
              <div className="reactionItem" onClick={tapLike}>
                <CrackerSVG />
              </div>
            </div>
          </>
        )}
        <button onClick={tapReaction}>
          <ReactionSVG />
          <div className="iconName">Reactions</div>
        </button>
      </div>
    </>
  );
};

export const Screenshare = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <img src="./images/buttons/screenShareButton.svg" alt="screenshare" /> */}
      <ScreenShareON />
      <div className="iconName">{t('bottom.Share')}</div>
    </>
  );
};

export const ScreenshareOn = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <img src="./images/buttons/screenShareOnButton.svg" alt="screenshare" /> */}
      <ScreenShareOFF />
      <div className="iconName">{t('bottom.Stop')}</div>
    </>
  );
};

export const EditNameButton = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <img src="./images/buttons/nftButton.svg" alt="nft" /> */}
      <EditNameSVG />
      <div className="iconName" style={{ color: '#E4D6FF' }}>
        {t('bottom.Edit Name')}
      </div>
    </>
  );
};

export const ViewCountOFF = () => {
  return (
    <>
      <ViewCountOFFSVG />
      <div className="iconName">
        <ViewerCount />
      </div>
    </>
  );
};

export const Leave = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <img src="./images/buttons/hangoutButton.svg" alt="leave" />{' '} */}
      <HangOutSVG />
      <div className="iconName">{t('bottom.End Call')}</div>
    </>
  );
};

export const Info = () => {
  return <img src="./images/buttons/hangoutButton.png" alt="info" />;
};

export const ChatIcon = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <img src="./images/buttons/chatButton.png" alt="chat" /> */}
      <ChatSVG />
      <div className="iconName">{t('bottom.Chat')}</div>
    </>
  );
};

export const ChatHighlighted = () => {
  const { t } = useTranslation();
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 18C16.4183 18 20 14.866 20 11C20 7.13401 16.4183 4 12 4C7.58172 4 4 7.13401 4 11C4 12.4358 4.49404 13.7707 5.3415 14.8815C5.47613 15.1546 5.75357 16.0287 5 17.7364C4.63024 18.4941 4.46711 19 5 19C6.12068 19 6.64893 18.6353 7.19788 18.2563C7.65602 17.9399 8.12858 17.6137 8.97197 17.4812C9.90599 17.8156 10.9284 18 12 18Z"
          fill="#f63135"
        />
      </svg>
      <div className="iconName">{t('bottom.Chat')}</div>
    </>
  );
};

export const BGMIcon = () => {
  return (
    <>
      <img src="./images/buttons/bgmButton.png" alt="bgm" />
      <div className="iconName">BGM</div>
    </>
  );
};

export const NftButton = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* <img src="./images/buttons/nftButton.svg" alt="nft" /> */}
      {/* <NFTSVG /> */}

      <LogoSVG />
      <div className="iconName" style={{ color: '#E4D6FF' }}>
        {t('bottom.Avatar')}
      </div>
    </>
  );
};

export const BackgroundButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <BackgroundSVG />
      <div className="iconName">{t('bottom.Background')}</div>
    </>
  );
};

export const SettingButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <SettingSVG />
      <div className="iconName">{t('bottom.Setting')}</div>
    </>
  );
};

export const ScreenShotButton = () => {
  return (
    <>
      {/* <img src="./images/buttons/screenShotButton.svg" alt="nft" /> */}
      <TakePicSVG />
      <div className="iconName">Take Pic</div>
    </>
  );
};

export const RecordStartButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <RecordStartSVG />
      <div className="iconName"> {t('bottom.Record')}</div>
    </>
  );
};

export const RecordStopButton = () => {
  const { t } = useTranslation();
  return (
    <>
      <RecordStopSVG />
      <div className="iconName" style={{ color: '#FF45B7' }}>
        {t('bottom.Record Stop')}
      </div>
    </>
  );
};

export const WaveButton = () => {
  return <img src="./images/buttons/waveButton.png" alt="eave" />;
};

export const InviteButton = () => {
  return <img src="./images/buttons/inviteButton.png" alt="invite" />;
};

export const Arrow = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 11.25C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75V11.25ZM19 12L19.5303 12.5303C19.8232 12.2374 19.8232 11.7626 19.5303 11.4697L19 12ZM14.5303 6.46967C14.2374 6.17678 13.7626 6.17678 13.4697 6.46967C13.1768 6.76256 13.1768 7.23744 13.4697 7.53033L14.5303 6.46967ZM13.4697 16.4697C13.1768 16.7626 13.1768 17.2374 13.4697 17.5303C13.7626 17.8232 14.2374 17.8232 14.5303 17.5303L13.4697 16.4697ZM5 12.75H19V11.25H5V12.75ZM19.5303 11.4697L14.5303 6.46967L13.4697 7.53033L18.4697 12.5303L19.5303 11.4697ZM18.4697 11.4697L13.4697 16.4697L14.5303 17.5303L19.5303 12.5303L18.4697 11.4697Z"
        fill="#121A24"
      />
    </svg>
  );
};
